window.addEventListener("message", function (event) {
  if (event.data && event.data.type === "shopify-analytics-event") {

    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get("page")) || 1;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: event.data.event,
      domain: window.location.host.split(".").pop() || null,
      page_index: page,
      page_title: event.data.page_title || null,
      page_location: event.data.page_location || null,
      ecommerce: event.data.ecommerce || null,
    });
  }
});
